import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {COLORS, ELEVATIONS, SIZES} from '../styleVars';
import {Typography} from '../typography/Typography';

const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
`;

const Switch = styled.div`
  display: inline-block;
  position: relative;
  outline: none;
  user-select: none;
  margin-left: ${SIZES['8']};
`;

interface TrackProps {
  checked: boolean;
}

const Track = styled.div<TrackProps>`
  background-color: ${(props) => (props.checked ? COLORS.fupaSecondary : COLORS.lightGrey)};
  width: ${SIZES['42']};
  height: ${SIZES['16']};
  border-radius: ${SIZES['12']};
  border: none;
`;

interface ThumbUnderlay {
  checked: boolean;
}

const ThumbUnderlay = styled.div<ThumbUnderlay>`
  left: ${(props) => (props.checked ? SIZES['10'] : `-${SIZES['16']}`)};
  right: auto;
  display: flex;
  position: absolute;
  top: -${SIZES['16']};
  align-items: center;
  justify-content: center;
  width: ${SIZES['48']};
  height: ${SIZES['48']};
`;

const Thumb = styled.div`
  box-shadow: ${ELEVATIONS.Button};
  box-sizing: border-box;
  width: ${SIZES['20']};
  height: ${SIZES['20']};
  border-radius: 50%;
  pointer-events: none;
  border: ${SIZES['10']} solid ${COLORS.white};
  z-index: 1;

  input {
    -webkit-tap-highlight-color: transparent;
    left: 0;
    right: auto;
    position: absolute;
    top: 0;
    height: ${SIZES['48']};
    margin: 0;
    opacity: 0;
    cursor: pointer;
    pointer-events: auto;
  }
`;

interface SwitchButtonProps {
  /**
   * Whether SwitchButton is initially activated
   */
  initiallyChecked?: boolean;
  /**
   * Label of the Button
   */
  label: string;
  /**
   * callbackFunction when the state of the button changes
   */
  onToggle: (state: boolean) => void;
  /**
   * tab-index of the Button, used to customize focus-order
   */
  tabIndex?: number;
}

const SwitchButton: React.FC<SwitchButtonProps> = ({initiallyChecked = false, label, onToggle, tabIndex = 0}) => {
  const [checked, setChecked] = useState<boolean>(initiallyChecked);

  useEffect(() => {
    onToggle(checked);
  }, [checked]);

  const handleClick = () => {
    setChecked(!checked);
  };

  return (
    <Container onClick={handleClick}>
      {/* @ts-ignore */}
      <Typography variant='caption1' component='label' htmlFor={label}>
        {label}
      </Typography>
      <Switch>
        <Track checked={checked} />
        <ThumbUnderlay checked={checked}>
          <Thumb>
            <input tabIndex={tabIndex} id={label} type='checkbox' role='switch' />
          </Thumb>
        </ThumbUnderlay>
      </Switch>
    </Container>
  );
};

export {SwitchButton};
